import { combineReducers } from "@reduxjs/toolkit";

import { accountReducer } from "@/features/account/account";
import authReducer from "@/features/auth/redux/auth.slice";
import { groupReducer } from "@/features/groups/group";
import { libraryReducer } from "@/features/lib/redux/lib.slice";
import { notificationReducer } from "@/features/notification/redux/notification.slice";

import { loadingReducer } from "./common.slice";

export const rootReducer = combineReducers({
  library: libraryReducer,
  auth: authReducer,
  account: accountReducer,
  group: groupReducer,
  common: loadingReducer,
  notification: notificationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
